import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  NotificationActionContract,
  NotificationNgrxActionContract,
} from '../../contracts/notification-action.contract';
import { Handler } from './handler.type';

export function createNgrxNotificationActionHandler(): Handler<NotificationNgrxActionContract> {
  const store = inject(Store);

  return {
    handle: (action: NotificationNgrxActionContract) => handleNgrxAction(action, store),
    support: isNotificationNgrxActionContract,
  };
}

function isNotificationNgrxActionContract(
  action: NotificationActionContract,
): action is NotificationNgrxActionContract {
  return 'action' in action;
}

export function handleNgrxAction(
  action: NotificationNgrxActionContract,
  store: Store,
): Promise<void> {
  if (!Array.isArray(action.action)) {
    store.dispatch(action.action);
    return Promise.resolve();
  }

  for (const actionItem of action.action) {
    store.dispatch(actionItem);
  }
  return Promise.resolve();
}
